import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA2H07mvgeeqxvxWpjjaU1lox-cn8y3PQQ",
  authDomain: "jc-creations-2bd12.firebaseapp.com",
  projectId: "jc-creations-2bd12",
  storageBucket: "jc-creations-2bd12.firebasestorage.app",
  messagingSenderId: "505521009931",
  appId: "1:505521009931:web:7b9bdb20af337e5dbfde0e"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

export { db };

export default firebase;